import { render, staticRenderFns } from "./LogsStats.vue?vue&type=template&id=4cdc72bc&scoped=true&"
import script from "./LogsStats.vue?vue&type=script&lang=js&"
export * from "./LogsStats.vue?vue&type=script&lang=js&"
import style0 from "./LogsStats.vue?vue&type=style&index=0&id=4cdc72bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdc72bc",
  null
  
)

export default component.exports